/**
 * Checks if a node matches the search term
 */
export const nodeMatchesSearch = (node, searchTerm) => {
	if (!searchTerm) return true;

	const searchLower = searchTerm.toLowerCase();
	const name = (node?.data?.name || '').toLowerCase();
	const accountId = (node?.data?.accountId || '').toString();

	return name.includes(searchLower) || accountId.includes(searchLower);
};
